import { Component } from '@angular/core';

import { GlobalInfoMessage } from '@app/shared/interfaces/info/global-info.interface';

@Component({
  selector: 'app-banned',
  templateUrl: './banned.page.html'
})
export class BannedPage {
  bannedMessage: GlobalInfoMessage = {
    title: 'BANNED.TITLE',
    description: 'BANNED.INFO',
    url_image: 'assets/imgs/banned/banned-logo.svg'
  };
}
